import React, { useMemo } from 'react'
import AboutArtwork from './AboutArtwork'
import OriginalProductDetails from './ProductDetails/Original'
import PrintProductDetails from './ProductDetails/Print'
import OriginalShippingAndReturns from './ShippingAndReturns/Original'
import PrintShippingAndReturns from './ShippingAndReturns/Print'
import { Tabs, TabPane } from 'components/SA/Tabs'
import Accordion from 'components/SA/Accordion'
import styles from './ArtworkDescription.module.scss'
import ContactUs from './components/ContactUs/ContactUs'

const ArtworkDescriptionSection = () => {
  const artworkDescriptionSectionItems = useMemo(() => {
    return [
      {
        title: 'ABOUT THE ARTWORK',
        content: <AboutArtwork />,
      },
      {
        title: 'DETAILS AND DIMENSIONS',
        content: (
          <>
            <OriginalProductDetails />
            <PrintProductDetails />
          </>
        ),
      },
      {
        title: 'SHIPPING AND RETURNS',
        content: (
          <>
            <OriginalShippingAndReturns />
            <PrintShippingAndReturns />
          </>
        ),
      },
    ]
  }, [])

  return (
    <>
      <div className={styles.artworkDescriptionDesktop}>
        <Tabs isOtherContentHidden={true}>
          <TabPane label='ABOUT THE ARTWORK' id='pdp_about_artwork_tab'>
            <AboutArtwork />
          </TabPane>
          <TabPane label='DETAILS AND DIMENSIONS' id='pdp_details_dimensions_tab'>
            <OriginalProductDetails />
            <PrintProductDetails />
          </TabPane>
          <TabPane label='SHIPPING AND RETURNS' id='pdp_shipping_returns_tab'>
            <OriginalShippingAndReturns />
            <PrintShippingAndReturns />
          </TabPane>
        </Tabs>
        <ContactUs />
      </div>

      <div className={styles.artworkDescriptionMobile}>
        <Accordion
          items={artworkDescriptionSectionItems}
          contentCustomStyle={styles.customAccordionContent}
          itemCustomStyle={styles.customAccordionItem}
          headerCustomStyle={styles.customAccordionHeader}
        />
        <ContactUs />
      </div>
    </>
  )
}

export default ArtworkDescriptionSection
